import PropTypes from 'prop-types';
import React from 'react';
import { capitalize } from 'lodash';
import SvgIcon from './SvgIcon';
import { THUMB_BUTTON_TEXT, THUMB_BUTTON_TEXT_SPANISH } from '../../constants/text';
import { actionOnKeyboardPress } from '../utils/browserUtils';

const handleOnClick = props => () => {
    props.onClick(props.text);
};

const ThumbButton = props => (
    <div
        tabIndex={props.isDisabled ? '-1' : 0}
        role="button"
        aria-label={capitalize(props.text)}
        aria-selected={props.selected}
        aria-disabled={props.isDisabled}
        className={`thumb-button${props.selected ? ' selected' : ''}`}
        onKeyDown={e => {
            actionOnKeyboardPress(e, handleOnClick(props));
        }}
        onClick={handleOnClick(props)}
    >
        <SvgIcon
            ariaDescribedBy={`Thumb ${
                props.text === THUMB_BUTTON_TEXT.YES || props.text === THUMB_BUTTON_TEXT_SPANISH.YES
                    ? 'up'
                    : 'down'
            } icon mean ${props.text}`}
            id={`thumb-${
                props.text === THUMB_BUTTON_TEXT.YES || props.text === THUMB_BUTTON_TEXT_SPANISH.YES
                    ? 'up'
                    : 'down'
            }`}
        />
        <div className="thumbContent">{props.text}</div>
    </div>
);

ThumbButton.propTypes = {
    text: PropTypes.string.isRequired,
    selected: PropTypes.bool,

    onClick: PropTypes.func,
    isDisabled: PropTypes.bool,
};

ThumbButton.defaultProps = {
    selected: false,
    onClick: () => {},
    isDisabled: false,
};

export default ThumbButton;
